import React from "react";
import { Clock, CheckCircle2, XCircle } from "lucide-react";

const map = {
  pending: {
    label: "Pending Approval",
    bg: "bg-[#FFF3E0]",
    text: "text-[#E65100]",
    icon: Clock,
  },
  approved: {
    label: "Approved",
    bg: "bg-[#E8F5E9]",
    text: "text-[#2E7D32]",
    icon: CheckCircle2,
  },
  rejected: {
    label: "Rejected",
    bg: "bg-[#FFEBEE]",
    text: "text-[#C62828]",
    icon: XCircle,
  },
};

export default function StatusBadge({ status, testId }) {
  const cfg = map[status] || map.pending;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold font-body ${cfg.bg} ${cfg.text}`}
      data-testid={testId || `status-${status}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {cfg.label}
    </span>
  );
}
